import "./AmSub.scss";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
    CustomButtonSmall,
    CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Tooltip,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TablePagination
} from "@mui/material";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import DOMPurify from 'dompurify';
import { fetchClientsBySearch, formatAmountsToDecimals, formatStringToNumberV2, numberToWordsWithDecimal } from "../../../utils/genericFunctions.js";
import newRequest from "../../../utils/newRequest.js";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import { GridLoader, ScaleLoader } from "react-spinners";
import { CiImageOn } from "react-icons/ci";
import { MdAdd, MdClose, MdDelete, MdEditDocument, MdEmail, MdOutlineNumbers, MdPhone, MdRefresh, MdSave, MdSms, MdDragIndicator, MdOutlineMenuOpen } from "react-icons/md";
import Badge from '@mui/material/Badge';
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { IoChatbubbles, IoDocumentTextSharp } from "react-icons/io5";
import { HiOutlineLink } from "react-icons/hi2";
import { RiAttachment2 } from "react-icons/ri";
import HRHandbook from "../../../components/test/HRHandbook.jsx";
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { TagIcon } from "lucide-react";
import Taccount from "../../../components/taccount/Taccount.jsx";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import Correspondence from "../../../components/correspondence/Correspondence.jsx";

const AmSub = () => {
    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const navigate = useNavigate();
    const location = useLocation();
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [subscriptionReceipts, setSubscriptionReceipts] = useState([]);
    const [selectedSubReceipt, setSelectedSubReceipt] = useState(null);
    const [profileLimitValues, setProfileLimitValues] = useState([]);
    const [subscriptionFees, setSubscriptionFees] = useState([]);
    const [selectedFee, setSelectedFee] = useState(null);
    const [figuresToShow, setFiguresToShow] = useState("org");
    const { docid } = useParams();
    const [subscriptionDocId, setSubscriptionDocId] = useState(null);
    const investorRef = useRef(null);
    const actionsMenuRef = useRef(null);
    const [additionalActionsMenu, setAdditionalActionsMenu] = useState(false);
    const [emailDialogOpen, setEmailDialogOpen] = useState(false);
    const [emailData, setEmailData] = useState(null);
    const [selectedInvestor, setSelectedInvestor] = useState(null);
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [nextAction, setNextAction] = useState("Complete");
    const [isConfettiActive, setIsConfettiActive] = useState(false);
    const [validationMsgDialog, setValidationMsgDialog] = useState(false);
    const [validationMessagesResult, setValidationMessagesResult] = useState({});
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        new_doc_status: "",
    });
    const [invokedAction, setInvokedAction] = useState("");
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [traceData, setTraceData] = useState([]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [allocatedFcAmountXx, setAllocatedFcAmountXx] = useState(0);
    const [allocatedLcAmountXx, setAllocatedLcAmountXx] = useState(0);

    const [totalReceiptFc, setTotalReceiptFc] = useState(0);
    const [totalReceiptLc, setTotalReceiptLc] = useState(0);

    const [totalFeesFc, setTotalFeesFc] = useState(0);
    const [totalFeesLc, setTotalFeesLc] = useState(0);

    const [branches, setBranches] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [priorityLevels, setPriorityLevels] = useState([]);
    const [funds, setFunds] = useState([]);
    const [selectedFund, setSelectedFund] = useState(null);
    const receiptRef = useRef(null);
    const [entityReceipts, setEntityReceipts] = useState([]);
    const [selectedReceipt, setSelectedReceipt] = useState(null);
    // top menu 
    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const [activeTab, setActiveTab] = useState(0);

    function getMenuTitle(menuKey) {
        switch (menuKey) {
            case 'details':
                return t('details');
            case 'attachments':
                return t('attachments');
            case 'matching':
                return t('matching');
            case 'correspondence':
                return t('correspondence');
            case 'comments':
                return t('comments');
            default:
                return '';
        }
    }

    const topMenus = [
        {
            menu_key: "details",
            menu_title: getMenuTitle("details"),
            menu_icon: <MdEditDocument />,
            menu_count: 0,
        },
        {
            menu_key: "attachments",
            menu_title: getMenuTitle("attachments"),
            menu_icon: <RiAttachment2 />,
            menu_count: attachmentsData.length,
        },
        {
            menu_key: "matching",
            menu_title: "Matching",
            menu_icon: <HiOutlineLink />,
            menu_count: 0,
        },
        {
            menu_key: "correspondence",
            menu_title: getMenuTitle("correspondence"),
            menu_icon: <MdSms />,
            menu_count: 0,
        },
        {
            menu_key: "comments",
            menu_title: getMenuTitle("comments"),
            menu_icon: <IoChatbubbles />,
            menu_count: 0,
        },
    ];


    const handleCloseNotifyDialog = () => {
        setIsNotifyDialogOpen(false);
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "completeSubscription") {
                let validateResponse = null;
                try {
                    validateResponse = await newRequest.get(`/fundSub/validate/${subscriptionDocId}`, { timeout: 5000 });
                } catch (error) {
                    if (error.code === 'ECONNABORTED') {
                        console.error("Request timed out!");
                        showToast(t('requestTimedOut'), "error");
                    } else {
                        console.error("Other error:", error.message);
                        showToast(error.message, "error");
                    }
                }
                // console.log(`validateResponse  ${JSON.stringify(validateResponse, null, 2)}`);

                if (validateResponse.data.result_status === "error") {
                    setIsProcessing(false);
                    setIsConfirmDialogOpen(false);
                    setValidationMessagesResult(validateResponse.data);
                    setValidationMsgDialog(true);
                    return;
                }

                await newRequest.put(`/fundSub/upd/${subscriptionDocId}`, {
                    hd_status: objectToAction?.new_doc_status,
                });

                try {
                    await newRequest.post(
                        "/trace/add",
                        {
                            trc_action_on: "Document",
                            trc_doc_docid: subscriptionData?._id,
                            trc_doc_no: subscriptionData?.hd_no,
                            trc_doc_type: "AM Fund Sub",
                            trc_aent_code: "",
                            trc_ent_code: subscriptionData?.investor_code,
                            trc_action: "updated document status",
                            trc_remarks: `updated subscription to ${objectToAction?.new_doc_status}`,
                            trc_tags: [`updated subscription to ${objectToAction?.new_doc_status}`],
                        },
                    );
                } catch (error) {
                    console.log(error);
                }
                showToast(t('documentValidated', { param1: subscriptionData?.hd_no }), "success");
                await fetchSubscription(subscriptionDocId);
            } else if (confirmDialogAction === "approveSubscription") {
                let validateResponse = null;
                try {
                    validateResponse = await newRequest.get(`/fundSub/validate/${subscriptionDocId}`, { timeout: 5000 });
                } catch (error) {
                    if (error.code === 'ECONNABORTED') {
                        console.error("Request timed out!");
                        showToast(t('requestTimedOut'), "error");
                    } else {
                        console.error("Other error:", error.message);
                        showToast(error.message, "error");
                    }
                }

                if (validateResponse.data.result_status === "error") {
                    setIsProcessing(false);
                    setIsConfirmDialogOpen(false);
                    setValidationMessagesResult(validateResponse.data);
                    setValidationMsgDialog(true);
                    return;
                }

                await newRequest.put(`/fundSub/upd/${subscriptionDocId}`, {
                    hd_status: objectToAction?.new_doc_status,
                });

                try {
                    await newRequest.post(
                        "/trace/add",
                        {
                            trc_action_on: "Document",
                            trc_doc_docid: subscriptionData?._id,
                            trc_doc_no: subscriptionData?.hd_no,
                            trc_doc_type: "AM Fund Sub",
                            trc_aent_code: "",
                            trc_ent_code: subscriptionData?.investor_code,
                            trc_action: "updated document status",
                            trc_remarks: `updated receipt to ${objectToAction?.new_doc_status}`,
                            trc_tags: [`updated receipt to ${objectToAction?.new_doc_status}`],
                        },
                    );
                } catch (error) {
                    console.log(error);
                }
                showToast(t('documentApproved', { param1: subscriptionData?.hd_no }), "success");
                await fetchSubscription(subscriptionDocId);
            } else if (confirmDialogAction === "cancelSubscription") {

            }
        } catch (err) {
            console.log(err);
        }
        setIsConfirmDialogOpen(false);
    };
 
    const fetchProfileLimits = async () => {
        try {
            const limitsToCheck = ["GB1000", "GB1001", "GB1002", "GB1003", "GB1004", "GB1005", "GB1006", "GB1007", "GB1008", "GB1009", "GB1010"];
            const limits = await newRequest.post("/adProfile/checkValues", { module_code: "am", limit_codes: limitsToCheck });
            setProfileLimitValues(limits.data)
        } catch (error) {
            console.log(error)
        }
    }

    // Function to get limit_yn value by limit_code
    const getLimitValue = (limitCode) => {
        try {
            const limit = profileLimitValues.find(l => l.limit_code === limitCode);
            return limit ? limit.limit_yn : null;
        } catch (error) {
            console.log(error)
        }
    };

    const fetchBranches = async () => {
        try {
            const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
            const options = res.data.map((branch) => ({
                value: branch?.unit_code,
                label: branch?.unit_name,
            }));
            setBranches(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const fetchCurrencies = async () => {
        try {
            const res = await newRequest.get("/glCurrency/findAll");
            const options = res.data.map((currency) => ({
                value: currency?.cur_code,
                label: currency?.cur_code,
            }));
            setCurrencies(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const fetchFunds = async () => {
        try {
            const res = await newRequest.post("/fund/findAll", {
                fund_status: "Active",
                result_limit: 100
            });
            const options = res.data?.map((codes) => ({
                nav_per_unit: codes?.nav_per_unit || 0,
                fund_docid: codes?._id,
                value: codes?.fund_code,
                label: codes?.fund_name,
            }));

            setFunds(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const fetchDocumentAttachments = async (docType, docid) => {
        try {
            const res = await newRequest.post(
                "/files/findDocFiles",
                {
                    fl_doc_type: docType,
                    fl_parent_doc_id: docid,
                });

            setAttachmentsData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchPriorityLevels = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "AM Priority Level" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));

            setPriorityLevels(options);
        } catch (error) {
            console.error("Error fetching security types :", error);
        }
    };

    const fetchSubscription = async (doc_id, firstTime = false) => {
        try {
            if (doc_id && doc_id !== "new") {
                if (firstTime) {
                    setIsLoading(true);
                }
                const res = await newRequest.get(`/fundSub/find/${doc_id}`);

                if (res.data) {
                    const formattedData = {
                        ...res.data,
                        hd_cur_rate: formatAmountsToDecimals(res.data?.hd_cur_rate || 0, 6),
                        hd_fc_amount: formatAmountsToDecimals(res.data?.hd_fc_amount || 0, 2),
                        hd_lc_amount: formatAmountsToDecimals(res.data?.hd_lc_amount || 0, 2),
                        nav_per_unit: formatAmountsToDecimals(res.data?.nav_per_unit || 0, 4),
                        units_allocated: formatAmountsToDecimals(res.data?.units_allocated || 0, 4),
                        hd_gl_date: res.data?.hd_gl_date ? moment(res.data?.hd_gl_date).format("YYYY-MM-DD") : null,
                    };
                    // console.log(`setSubscriptionData ${JSON.stringify(res.data, null, 2)}`);
                    setSubscriptionData(formattedData);

                    const formattedReceipts = res.data?.hd_receipts?.map(receipt => ({
                        ...receipt,
                        receipt_fc_amount: formatAmountsToDecimals(receipt?.receipt_fc_amount, 2),
                        receipt_lc_amount: formatAmountsToDecimals(receipt?.receipt_lc_amount, 2),
                    }));
                    setSubscriptionReceipts(formattedReceipts);

                    const formattedFees = res.data?.subscription_fees_xx?.map(fee => ({
                        ...fee,
                        fee_rate: formatAmountsToDecimals(fee?.fee_rate, 6),
                        fee_amount_fc: formatAmountsToDecimals(fee?.fee_amount_fc, 2),
                        fee_amount_lc: formatAmountsToDecimals(fee?.fee_amount_lc, 2),

                    }));
                    setSubscriptionFees(formattedFees);

                    setSubscriptionDocId(res.data._id);
                    setDocumentEnabled(res.data.document_enabled_xx);
                    setNextAction(res.data.next_action_xx);

                    if (res.data?.investor_details_xx) {
                        setSelectedInvestor({
                            ent_docid: res.data?.investor_details_xx?._id,
                            ent_occupation_xx: res.data?.investor_details_xx?.ent_occupation_xx,
                            ent_email: res.data?.investor_details_xx?.ent_email,
                            ent_phone_no: res.data?.investor_details_xx?.ent_phone_no,
                            ent_photo_url: res.data?.investor_details_xx?.ent_photo_url,
                            ent_status: res.data?.investor_details_xx?.ent_status,
                            aent_name_xx: res.data?.investor_details_xx?.aent_name_xx,
                            ent_code: res.data?.investor_details_xx?.ent_code,
                            ent_aent_code: res.data?.investor_details_xx?.ent_aent_code,
                            ent_name: res.data?.investor_details_xx?.ent_name,
                            value: res.data?.investor_details_xx?.ent_code,
                            label: (
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                                    {res.data?.investor_details_xx?.ent_name}
                                </div>
                            ),
                        });
                    } else {
                        setSelectedInvestor(null);
                    }

                    if (res.data.document_enabled_xx === "Y") {
                        await callDetailsFunction();
                    }

                    await fetchTrace(res.data?.hd_no);

                    fetchDocumentAttachments("am fund sub", res.data._id);
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            }
        }
    };

    const fetchEntityReceipts = async (entCode, payingFor) => {
        try {
            const res = await newRequest.post("/arReceiptLn/receiptsByPayingFor", {
                ln_ent_code: entCode,
                ln_paying_for: payingFor
            });

            const options = res.data?.docs?.map((receipt) => ({
                receipt_docid: receipt?.receipt_docid,
                line_docid: receipt?.line_docid,
                ln_fc_amount: receipt?.ln_fc_amount,
                ln_lc_amount: receipt?.ln_lc_amount,
                value: receipt?.line_docid,
                label: (
                    <div style={{ display: "flex", width: "100%", flexDirection: "column", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                            <span className="sub-title">{receipt?.ln_hd_no}</span> <span className="sub-title" style={{ fontSize: "10px", color: "red" }}>{currentUser?.currency_code_xx}</span>
                        </div>
                        <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                            <span className="sub-title" style={{ fontSize: "10px" }}>{receipt?.formatted_gldate_xx}</span> <span className="sub-title">{numeral(receipt?.ln_lc_amount).format("0,0.00")}</span>
                        </div>
                    </div>
                ),
                isDisabled: receipt.ln_hd_status !== "Approved"
            }));
            setEntityReceipts(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const saveRecord = async (e) => {
        try {
            if (!selectedInvestor) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select investor!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!subscriptionData?.fund_code) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select fund!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            const refreshedAmounts = recalculateAmounts();

            setTotalReceiptFc(refreshedAmounts?.fcTotalReceipts);
            setTotalReceiptLc(refreshedAmounts?.lcTotalReceipts);
            setTotalFeesFc(refreshedAmounts?.fcTotalFees);
            setTotalFeesLc(refreshedAmounts?.lcTotalFees);

            // console.log(`subscriptionData ${JSON.stringify(subscriptionData, null, 2)}`);

            const formattedData = {
                ...subscriptionData,
                investor_docid: selectedInvestor?.ent_docid,
                investor_code: selectedInvestor?.ent_code,
                hd_cur_rate: parseFloat(formatStringToNumberV2(subscriptionData?.hd_cur_rate || 0, 6)) || 0,
                nav_per_unit: parseFloat(formatStringToNumberV2(subscriptionData?.nav_per_unit || 0, 4)) || 0,
                units_allocated: parseFloat(formatStringToNumberV2(refreshedAmounts?.totalUnitsAllocated || 0, 4)) || 0,
                hd_fc_amount: parseFloat(formatStringToNumberV2(refreshedAmounts?.fcTotalReceipts || 0, 2)) || 0,
                hd_lc_amount: parseFloat(formatStringToNumberV2(refreshedAmounts?.lcTotalReceipts || 0, 2)) || 0,
            };

            // console.log(`formattedData ${JSON.stringify(formattedData, null, 2)}`);

            if (subscriptionDocId === "new" || subscriptionDocId === undefined) {
                // generate transaction number
                const numGen = await newRequest.post("/orgNumgen/gen", { gen_type: "AM Subscription", },);

                if (!numGen?.data && !subscriptionData?.hd_no) {
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(`Number generation for subscriptions not set!`);
                    setIsNotifyDialogOpen(true);
                    return;
                }

                // console.log(`inserting ${JSON.stringify({ ...formattedData, hd_no: numGen?.data }, null, 2)}`);
                const res = await newRequest.post("/fundSub/add", { ...formattedData, hd_no: numGen?.data, units_allocated: 0 });
                if (res.data?.msg === "added") {
                    setNotifyDialogTitle(t('success'));
                    setNotifyDialogText(t('successSaved', { param1: numGen?.data }));
                    setIsNotifyDialogOpen(true);
                    // console.log(`fetching... ${JSON.stringify(res.data, null, 2)}`);
                    await fetchSubscription(res.data?.doc?._id);
                    navigate(`/amsubs/${res.data?.doc?._id}`, { replace: true });
                } else if (res.data?.msg === "exists") {
                    showToast(t('transactionExists', { param1: res.data?.doc?.hd_no }), "success");
                } else {
                    showToast(res.data?.msg, "error");
                }
            } else {
                const formattedReceipts = subscriptionReceipts?.map(receipt => ({
                    ...receipt,
                    receipt_fc_amount: parseFloat(formatStringToNumberV2(receipt?.receipt_fc_amount, 2)),
                    receipt_lc_amount: parseFloat(formatStringToNumberV2(receipt?.receipt_lc_amount, 2)),
                }));
                // console.log(`formattedReceipts ${JSON.stringify(formattedReceipts, null, 2)}`);
                const res = await newRequest.put(`/fundSub/upd/${subscriptionData?._id}`, { ...formattedData, hd_receipts: formattedReceipts || [] });
                setNotifyDialogTitle(t('success'));
                setNotifyDialogText(t('successSaved', { param1: subscriptionData?.hd_no }));
                setIsNotifyDialogOpen(true);
            }
        } catch (err) {
            setIsLoading(false);
            console.log(err);
        }
    };

    const fetchTrace = async (subscriptionNo) => {
        try {
            const res = await newRequest.post(
                "/trace/findDoc",
                {
                    trc_doc_type: "AM Fund Sub",
                    trc_doc_no: subscriptionNo
                }
            );
            setTraceData(res.data);
        } catch (err) {
            console.log(err);
        }
    };


    const callDetailsFunction = async () => {
        try {
            await fetchFunds();
            await fetchBranches();
            await fetchCurrencies();
            await fetchPriorityLevels();
        } catch (err) {
            console.log(err);
        }
    };

    const handleSetSubscriptionData = (name, value) => {
        setSubscriptionData((prev) => {
            return { ...prev, [name]: value };
        });
    };

    const handleSubReceiptChange = (e, id, field) => {
        try {
            const updatedData = [...subscriptionReceipts];
            const index = updatedData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                // console.log(`subscriptionData?.hd_cur_rate . ${subscriptionData?.hd_cur_rate}`);
                const numberFields = ["receipt_fc_amount", "receipt_lc_amount"];
                if (numberFields.includes(field)) {
                    updatedData[index][field] = formatStringToNumberV2(e.target.value);
                    const fcAmount = Number(parseFloat(formatStringToNumberV2(e.target.value) / subscriptionData?.hd_cur_rate).toFixed(4));
                    updatedData[index]["receipt_fc_amount"] = fcAmount;
                } else {
                    updatedData[index][field] = e.target.value;
                }
                setSubscriptionReceipts(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSubReceiptBlur = (id, field) => {
        try {
            const updatedData = [...subscriptionReceipts];
            // console.log(`... updatedData  ${JSON.stringify(updatedData, null, 2)}`);
            const index = updatedData.findIndex(smi => smi._id === id);
            // console.log(`... index  ${JSON.stringify(index, null, 2)}`);

            if (index !== -1) {
                const value = updatedData[index][field];
                const numberFields = ["receipt_fc_amount", "receipt_lc_amount"];
                if (numberFields.includes(field)) {
                    let receiptAmountLc = parseFloat(formatStringToNumberV2(updatedData[index]["ln_lc_amount"] || 0));
                    // console.log(`value ${JSON.stringify(value, null, 2)}`);
                    // console.log(`receiptAmountLc ${JSON.stringify(receiptAmountLc, null, 2)}`);
                    // console.log(`receiptAmountFc ${JSON.stringify(receiptAmountFc, null, 2)}`);
                    if (parseFloat(formatStringToNumberV2(value)) > receiptAmountLc) {
                        updatedData[index][field] = formatAmountsToDecimals(receiptAmountLc, 2);
                        const fcAmount = Number(parseFloat(formatStringToNumberV2(receiptAmountLc) / subscriptionData?.hd_cur_rate).toFixed(4));
                        updatedData[index]["receipt_fc_amount"] = formatAmountsToDecimals(fcAmount, 2);
                        setNotifyDialogTitle(t('note'));
                        setNotifyDialogText(`You cannot allocate amount greater than the receipt amount of ${numeral(receiptAmountLc).format("0,0.00")}!`);
                        setIsNotifyDialogOpen(true);
                    } else {
                        updatedData[index][field] = formatAmountsToDecimals(value);
                    }
                } else {
                    updatedData[index][field] = value;
                }
                updatedData[index]["changed_xx"] = "Y";
                setSubscriptionReceipts(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const recalculateAmounts = () => {
        try {
            let fcTotalReceipts = 0;
            let lcTotalReceipts = 0;

            for (const item of subscriptionReceipts) {
                const fc = parseFloat(formatStringToNumberV2(item?.receipt_fc_amount || 0)) || 0;
                const lc = parseFloat(formatStringToNumberV2(item?.receipt_lc_amount || 0)) || 0;
                fcTotalReceipts += isNaN(fc) ? 0 : fc;
                lcTotalReceipts += isNaN(lc) ? 0 : lc;
            }

            let fcTotalFees = 0;
            let lcTotalFees = 0;
            for (const fee of subscriptionFees) {
                const fc = parseFloat(formatStringToNumberV2(fee?.fee_amount_fc || 0)) || 0;
                const lc = parseFloat(formatStringToNumberV2(fee?.fee_amount_lc || 0)) || 0;
                fcTotalFees += isNaN(fc) ? 0 : fc;
                lcTotalFees += isNaN(lc) ? 0 : lc;
            }

            const fcNetAmount = fcTotalReceipts - fcTotalFees;
            const lcNetAmount = lcTotalReceipts - lcTotalFees;

            console.log(`fcTotalReceipts ... ${fcTotalReceipts}`);
            console.log(`lcTotalReceipts ... ${lcTotalReceipts}`);
            console.log(`fcTotalFees ... ${fcTotalFees}`);
            console.log(`lcTotalFees ... ${lcTotalFees}`);
            console.log(`fcNetAmount ... ${fcNetAmount}`);
            console.log(`lcNetAmount ... ${lcNetAmount}`);
            console.log(`subscriptionData?.nav_per_unit ... ${subscriptionData?.nav_per_unit}`);
            // const fcNetAmount = fcTotalReceipts;
            // const lcNetAmount = lcTotalReceipts;
            //calculate total units allocated by dividing total receipts with nav at subscription
            const totalUnitsAllocated = (lcNetAmount / subscriptionData?.nav_per_unit).toFixed(4) || 0;
            console.log(`totalUnitsAllocated ... ${totalUnitsAllocated}`);
            return {
                totalUnitsAllocated,
                fcTotalReceipts,
                lcTotalReceipts,
                fcTotalFees,
                lcTotalFees,
                fcNetAmount,
                lcNetAmount
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
                setAdditionalActionsMenu(false);
            }
        }

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        if (docid) {
            setSubscriptionDocId(docid);
        }
    }, [docid]);

    // calculate total receipts
    useEffect(() => {
        if (!Array.isArray(subscriptionReceipts)) return;
        if (!Array.isArray(subscriptionFees)) return;

        const refreshedAmounts = recalculateAmounts();

        handleSetSubscriptionData("units_allocated", formatAmountsToDecimals(refreshedAmounts?.totalUnitsAllocated, 4));
        handleSetSubscriptionData("hd_fc_amount", formatAmountsToDecimals(refreshedAmounts?.fcTotalReceipts, 4));
        handleSetSubscriptionData("hd_lc_amount", formatAmountsToDecimals(refreshedAmounts?.lcTotalReceipts, 4));
        setTotalReceiptFc(refreshedAmounts?.fcTotalReceipts);
        setTotalReceiptLc(refreshedAmounts?.lcTotalReceipts);
        setTotalFeesFc(refreshedAmounts?.fcTotalFees);
        setTotalFeesLc(refreshedAmounts?.lcTotalFees);
    }, [subscriptionReceipts]);

    // refresh entity receipts
    useEffect(() => {
        if (selectedInvestor?.value) {
            fetchEntityReceipts(selectedInvestor?.value, "Investment");
        }
    }, [selectedInvestor]);


    useEffect(() => {
        if (subscriptionDocId === "new" || subscriptionDocId === undefined) {
            setSubscriptionDocId("new");
            setDocumentEnabled("Y");
            callDetailsFunction();
            if (investorRef.current) {
                investorRef.current.focus();
            }

            setSubscriptionData({
                hd_status: "New",
                hd_priority: "Normal",
                hd_gl_date: moment().format("YYYY-MM-DD"),
                hd_biz_unit: currentUser?.biz_unit_code_xx,
                hd_cur_code: currentUser?.currency_code_xx,
                hd_cur_rate: 1,
                hd_fc_amount: 0,
                hd_lc_amount: 0,
                nav_per_unit: 0,
                units_allocated: 0,
                hd_receipts: []
            })
        } else {
            fetchSubscription(subscriptionDocId, true);
        }
        fetchProfileLimits();
    }, [subscriptionDocId]);

    return (
        <motion.div
            className="am-sub"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <div className="am-sub-main-wrapper">
                    <div className="am-sub-navbar">
                        <div className="am-sub-navbar-left">
                            <span className="main-title">{subscriptionData?.hd_no || t('newSubscription')}</span>
                            <span className="sub-title">{subscriptionDocId !== "new" && `${subscriptionData?.hd_status}`}</span>
                        </div>
                        <div className="am-sub-navbar-right">
                            {documentEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="left"
                                    endIcon={<MdRefresh />}
                                    onClick={async () => { await fetchSubscription(subscriptionDocId) }}
                                >
                                    {t('refresh')}
                                </CustomLoadingButton>
                            )}
                            {subscriptionDocId !== "new" && nextAction !== "None" && (
                                <>
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="none"
                                        endIcon={<MdDragIndicator />}
                                        onClick={() => {
                                            try {
                                                let action_text = "";
                                                let new_doc_status = subscriptionData?.hd_status;
                                                switch (subscriptionData?.hd_status) {
                                                    case "New":
                                                        action_text = `Do you want to Complete this transaction?`;
                                                        setConfirmDialogAction("completeSubscription");
                                                        new_doc_status = "Completed";
                                                        break;
                                                    case "Completed":
                                                        action_text = `Do you want to Approve this transaction?`;
                                                        setConfirmDialogAction("approveSubscription");
                                                        new_doc_status = "Approved";
                                                        break;
                                                    case "Approved":
                                                        action_text = `Do you want to cancel this transaction?`;
                                                        setConfirmDialogAction("cancelSubscription");
                                                        new_doc_status = "Cancelled";
                                                        break;
                                                    default:
                                                        action_text = "";
                                                        new_doc_status = "";
                                                }
                                                setObjectToAction({
                                                    object_id: subscriptionData._id,
                                                    action_text: action_text,
                                                    new_doc_status,
                                                });
                                                setIsConfirmDialogOpen(true);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {nextAction}
                                    </CustomLoadingButton>
                                </>
                            )}
                            {documentEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<MdSave />} onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            {subscriptionDocId !== "new" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<IoDocumentTextSharp />}
                                    onClick={() => setReportsDialogOpen(true)}>
                                    {t('reports')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="right"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>

                            <div className="icon-container"
                                ref={actionsMenuRef}
                                onClick={(e) => {
                                    try {
                                        e.stopPropagation();
                                        setAdditionalActionsMenu(!additionalActionsMenu)
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }}>
                                <MdOutlineMenuOpen className="icon" />
                                {additionalActionsMenu && (
                                    <div className="dropdown">
                                        {subscriptionData?.hd_status === "Transmitted" &&
                                            <div className="dropdown-item"
                                                onClick={() => {
                                                    try {
                                                        // if (getLimitValue("GB1005") === "N") {
                                                        //     setNotifyDialogTitle("Note!");
                                                        //     setNotifyDialogText(`GB1005: You are not authorized to put ${entName} Under Review!`);
                                                        //     setIsNotifyDialogOpen(true);
                                                        //     return;
                                                        // }
                                                        // const action_text = `Are you sure you want to put ${entName} UNDER REVIEW?. Please note all transactions related to this entity that are in progress cannot be approved until the account returns to ACTIVE state.`;
                                                        // setObjectToAction({
                                                        //     object_id: entityId,
                                                        //     action_text: action_text,
                                                        // });
                                                        // setConfirmDialogAction("underReview");
                                                        // setIsConfirmDialogOpen(true);
                                                    } catch (error) {
                                                        console.log(error)
                                                    }
                                                }}>{t('settleTrade')}</div>}
                                        {subscriptionData?.hd_status === "Transmitted" &&
                                            <div className="dropdown-item"
                                                onClick={() => {
                                                    try {
                                                        // if (getLimitValue("GB1007") === "N") {
                                                        //     setNotifyDialogTitle("Note!");
                                                        //     setNotifyDialogText(`GB1007: You are not authorized to RE-ACTIVATE ${entName}!`);
                                                        //     setIsNotifyDialogOpen(true);
                                                        //     return;
                                                        // }
                                                        // const action_text = `Are you sure you want to RE-ACTIVATE ${entName}?`;
                                                        // setObjectToAction({
                                                        //     object_id: entityId,
                                                        //     action_text: action_text,
                                                        // });
                                                        // setConfirmDialogAction("reactivateAccount");
                                                        // setIsConfirmDialogOpen(true);
                                                    } catch (error) {
                                                        console.log(error)
                                                    }
                                                }}
                                            >{t('cancel')}</div>}
                                        {subscriptionData?.hd_status === "Transmitted" &&
                                            <div className="dropdown-item"
                                                onClick={() => {
                                                    try {
                                                        // if (getLimitValue("GB1006") === "N") {
                                                        //     setNotifyDialogTitle("Note!");
                                                        //     setNotifyDialogText(`GB1006: You are not authorized to CLOSE ${entName}!`);
                                                        //     setIsNotifyDialogOpen(true);
                                                        //     return;
                                                        // }
                                                        // const action_text = `Are you sure you want to CLOSE ${entName}?. Please note this action is irrevasible. A CLOSED account CANNOT be reopened. All transactions related to this entity that are in progress cannot be approved.`;
                                                        // setObjectToAction({
                                                        //     object_id: entityId,
                                                        //     action_text: action_text,
                                                        // });
                                                        // setConfirmDialogAction("closeAccount");
                                                        // setIsConfirmDialogOpen(true);
                                                    } catch (error) {
                                                        console.log(error)
                                                    }
                                                }}
                                            >{t('review')}</div>}
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                    <div className="content-summary-wrapper">
                        <div className="content-wrapper">
                            <div className="tabs-container">
                                <div className="tab-header">
                                    {topMenus?.map((tab, index) => (
                                        <div
                                            key={index}
                                            className={`${activeTab === index ? 'tab active' : 'tab'}`}
                                            onClick={() => handleTabClick(index)}
                                        >
                                            <span className={`${activeTab === index ? 'tab-icon active' : 'tab-icon'}`}>
                                                {tab.menu_icon}
                                            </span>
                                            <span className={`${activeTab === index ? 'tab-title active' : 'tab-title'}`}>{tab.menu_title}</span>
                                            {tab.menu_count > 0 && <Badge badgeContent={tab.menu_count} showZero
                                                className={activeTab === index ? "tab-badge active" : "tab-badge"} />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="subscription-content-details">
                                {/* Summary Information */}
                                {activeTab === 0 &&
                                    <>
                                        {documentEnabled === "N" &&
                                            <div className="content-details-row approved-doc">
                                                <span>{`${t('no').toUpperCase()}: ${subscriptionData?.hd_no}`}</span>
                                                <span>{`${t('bizUnit').toUpperCase()}: ${subscriptionData?.hd_biz_unit}`}</span>
                                                <span>{`${t('status').toUpperCase()}: ${subscriptionData?.hd_status}`}</span>
                                            </div>}
                                        {/* received from */}
                                        <ExpandableComponent
                                            title={t('investor').toUpperCase()}
                                            subtitle={<span className="main-title"> {selectedInvestor?.ent_occupation_xx}</span>}
                                            defaultExpanded={true}
                                        >
                                            <div className="content-details-row client">
                                                <motion.div
                                                    className="entity-details-container"
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1, transition: { duration: 1 } }}
                                                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                                                    <div className="entity-details-wrapper">
                                                        <div className="entity-details-left">
                                                            {selectedInvestor?.ent_photo_url ?
                                                                <img src={selectedInvestor?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                                        </div>
                                                        <div className="entity-details-right">
                                                            <div className="name-row">
                                                                {documentEnabled === "Y" ?
                                                                    <div className="input-item-with-label">
                                                                        <AsyncSelect
                                                                            ref={investorRef}
                                                                            id="investor_ent"
                                                                            name="investor_ent"
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="350px"
                                                                            isClearable
                                                                            value={selectedInvestor}
                                                                            onChange={(selectedOption) => {
                                                                                try {
                                                                                    setSelectedInvestor(selectedOption);
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                                                                            isSearchable={true}
                                                                            placeholder={t('investor').toUpperCase()}
                                                                            noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <span className="main-title"> {subscriptionData?.investor_details_xx?.ent_name} </span>}
                                                            </div>
                                                            <div className="email-phone-row">
                                                                <span className="email-phone-details" style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        try {
                                                                            setEmailData({
                                                                                to: subscriptionData?.investor_details_xx?.ent_email,
                                                                                cc: '',
                                                                                bcc: '',
                                                                                subject: `RECEIPT NO ${subscriptionData?.hd_no}`,
                                                                                show_attach: "Y",
                                                                                attached_urls: [],
                                                                                binary_docs: [],
                                                                                doc_no: subscriptionData?.hd_no,
                                                                                doc_type: "AM Fund Sub",
                                                                                doc_id: subscriptionDocId,
                                                                                entity_codes: [subscriptionData?.investor_details_xx?.value],
                                                                                search_string: subscriptionData?.investor_details_xx?.label?.props?.children[0] + "," + subscriptionData?.hd_no,
                                                                                carrierName: '',
                                                                                productName: '',
                                                                                clientName: subscriptionData?.investor_details_xx?.label?.props?.children[0],
                                                                                riskNoteNo: subscriptionData?.hd_no,
                                                                                daysToRenewal: subscriptionData?.expiring_in_days,
                                                                                expiryDate: subscriptionData?.fmt_to_date,
                                                                                insuredName: subscriptionData?.investor_details_xx?.label?.props?.children[0],
                                                                                outstandingPremium: subscriptionData?.outstandingPremium,
                                                                                policyCurrency: subscriptionData?.hd_cur_code,
                                                                                policyNumber: subscriptionData?.hd_no,
                                                                                policyPremium: subscriptionData?.fmt_policy_fc_prem,
                                                                                policyPremiumTotal: subscriptionData?.fmt_total_fc_prem,
                                                                                policySumInsured: subscriptionData?.fmt_total_fc_si,
                                                                                policyFromDate: subscriptionData?.fmt_fm_date,
                                                                                policyToDate: subscriptionData?.fmt_to_date,
                                                                                tpt_category: []
                                                                            });
                                                                            setEmailDialogOpen(true);
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}>
                                                                    <MdEmail className="icon" /> <h1 className="sub-title">{selectedInvestor?.ent_email || "Unspecified"}</h1>
                                                                </span>
                                                                <span className="email-phone-details">
                                                                    <MdPhone className="icon" /> <h1 className="sub-title">{selectedInvestor?.ent_phone_no || "Unspecified"}</h1>
                                                                </span>
                                                                <span className="email-phone-details">
                                                                    <MdOutlineNumbers className="icon" /> <h1 className="sub-title">{selectedInvestor?.aent_name_xx || ""}</h1>
                                                                </span>
                                                                <span className="email-phone-details"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        try {
                                                                            navigate(`/entity/${selectedInvestor?.ent_docid}`);
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}>
                                                                    <TagIcon className="icon" /> <h1 className="sub-title">{selectedInvestor?.ent_code}</h1>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </ExpandableComponent>
                                        {/* end of transaction  */}
                                        {/* transaction details */}
                                        <ExpandableComponent
                                            title={t('details').toUpperCase()}
                                            subtitle={<span className={`status ${subscriptionData?.hd_status}`}>{`${t('status').toUpperCase()} ${subscriptionData?.hd_status}`}</span>}
                                            defaultExpanded={true}
                                        >
                                            <div className="content-details-row">
                                                <div className="content-details-left">
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="fund_code" className="form-dropdown-label" style={{ width: "100px" }}>{t('fund').toUpperCase()}</label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="fund_code"
                                                                name="fund_code"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="450px"
                                                                value={funds.find(option => option.value === subscriptionData?.fund_code) || null}
                                                                onChange={selectedOption => {
                                                                    try {
                                                                        console.log(`selectedOption ... ${JSON.stringify(selectedOption, null, 2)}`);
                                                                        handleSetSubscriptionData("fund_code", selectedOption?.value);
                                                                        handleSetSubscriptionData("fund_docid", selectedOption?.fund_docid);
                                                                        handleSetSubscriptionData("nav_per_unit", selectedOption?.nav_per_unit);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                                options={funds}
                                                                isSearchable={true}
                                                                isDisabled={documentEnabled === "N"}
                                                                placeholder={t('fund').toUpperCase()}
                                                            /> :
                                                            <input
                                                                id="fund_name_xx"
                                                                name="fund_name_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "450px" }}
                                                                value={subscriptionData?.fund_name_xx}
                                                                disabled={true}
                                                            />}
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "start",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                    }}>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_ref_no"
                                                                className="form-dropdown-label"
                                                                style={{ width: "100px" }}
                                                            >
                                                                {t('ref').toUpperCase()}
                                                            </label>
                                                            <input
                                                                id="hd_ref_no"
                                                                name="hd_ref_no"
                                                                type="text"
                                                                placeholder={t('ref').toUpperCase()}
                                                                value={subscriptionData?.hd_ref_no}
                                                                className="form-input-item"
                                                                style={{ width: "170px" }}
                                                                onChange={selectedOption => handleSetSubscriptionData("hd_ref_no", selectedOption?.value)}
                                                                disabled={documentEnabled === "N"}
                                                            />
                                                        </div>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_lc_amount"
                                                                className="form-dropdown-label"
                                                                style={{ width: "max-content" }}
                                                            >
                                                                {t('converted').toUpperCase()}
                                                            </label>
                                                            <input
                                                                id="hd_fc_amount"
                                                                name="hd_fc_amount"
                                                                type="text"
                                                                placeholder="0.00"
                                                                className="form-input-item"
                                                                style={{ width: "170px", textAlign: "end" }}
                                                                value={numeral(totalReceiptFc).format("0,0.00")}
                                                                disabled={true}
                                                            />
                                                        </div>

                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_biz_unit"
                                                                className="form-dropdown-label"
                                                                style={{ width: "100px" }}
                                                            >
                                                                {t('bizUnit').toUpperCase()}
                                                            </label>
                                                            {documentEnabled === "Y" ?
                                                                <Select
                                                                    id="hd_biz_unit"
                                                                    name="hd_biz_unit"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark"
                                                                            ? customSelectStyles_dark
                                                                            : customSelectStyles_light),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                    width="170px"
                                                                    value={branches.find(option => option.value === subscriptionData?.hd_biz_unit) || null}
                                                                    onChange={selectedOption => handleSetSubscriptionData("hd_biz_unit", selectedOption?.value)}
                                                                    options={branches}
                                                                    isSearchable={true}
                                                                    isDisabled={documentEnabled === "N"}
                                                                    placeholder={t('bizUnit').toUpperCase()}
                                                                /> :
                                                                <input
                                                                    id="bizunit_name_xx"
                                                                    name="bizunit_name_xx"
                                                                    type="text"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={subscriptionData?.bizunit_name_xx}
                                                                    disabled={true}
                                                                />}
                                                        </div>
                                                        <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                                            <label
                                                                htmlFor="hd_cur_code"
                                                                className="form-dropdown-label"
                                                                style={{ width: "80px" }}
                                                            >
                                                                {t('currency').toUpperCase()}
                                                            </label>
                                                            {documentEnabled === "Y" ?
                                                                <Select
                                                                    id="hd_cur_code"
                                                                    name="hd_cur_code"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark"
                                                                            ? customSelectStyles_dark
                                                                            : customSelectStyles_light),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                    width="170px"
                                                                    value={currencies.find(option => option.value === subscriptionData?.hd_cur_code) || null}
                                                                    onChange={async (selectedOption) => {
                                                                        try {
                                                                            if (selectedOption.value !== currentUser?.currency_code_xx) {
                                                                                handleSetSubscriptionData("hd_cur_code", selectedOption?.value);
                                                                                const formattedDate = moment(subscriptionData?.hd_gl_date).format("YYYY-MM-DD");
                                                                                const res = await newRequest.post("/glCurrencyRate/find", {
                                                                                    rate_org_code: currentUser.usr_org_code,
                                                                                    rate_cur_code_fm: selectedOption.value,
                                                                                    rate_cur_code_to: currentUser?.currency_code_xx,
                                                                                    rate_date: formattedDate,
                                                                                });

                                                                                if (res.data) {
                                                                                    handleSetSubscriptionData("hd_cur_rate", res.data.rate);
                                                                                } else {
                                                                                    handleSetSubscriptionData("hd_cur_code", currentUser?.currency_code_xx);
                                                                                    handleSetSubscriptionData("hd_cur_rate", 1);
                                                                                    setNotifyDialogTitle("Note!");
                                                                                    setNotifyDialogText(
                                                                                        `Conversion Rate from <strong>${selectedOption.value} to ${currentUser?.currency_code_xx} for date ${moment(subscriptionData?.hd_gl_date).format(
                                                                                            "DD-MMM-YYYY"
                                                                                        )}</strong> NOT found. Currency will reset to <strong>${currentUser?.currency_code_xx}</strong>`
                                                                                    );
                                                                                    setIsNotifyDialogOpen(true);
                                                                                }
                                                                            } else {
                                                                                handleSetSubscriptionData("hd_cur_code", currentUser?.currency_code_xx);
                                                                                handleSetSubscriptionData("hd_cur_rate", 1);
                                                                                const lcAmount = Number(parseFloat(formatStringToNumberV2(subscriptionData?.hd_fc_mount)).toFixed(4));
                                                                                handleSetSubscriptionData("hd_lc_mount", lcAmount);
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    options={currencies}
                                                                    isSearchable={true}
                                                                    isDisabled={documentEnabled === "N"}
                                                                    placeholder={t('currency').toUpperCase()}
                                                                /> :
                                                                <input
                                                                    id="hd_cur_code_xx"
                                                                    name="hd_cur_code_xx"
                                                                    type="text"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={subscriptionData?.hd_cur_code}
                                                                    disabled={true}
                                                                />}
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "start",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                    }}>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_priority"
                                                                className="form-dropdown-label" style={{ width: "100px" }}
                                                            >
                                                                {t('priority').toUpperCase()}
                                                            </label>
                                                            {documentEnabled === "Y" ?
                                                                <Select
                                                                    id="hd_priority"
                                                                    name="hd_priority"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="170px"
                                                                    value={priorityLevels.find(option => option.value === subscriptionData?.hd_priority) || null}
                                                                    onChange={selectedOption => handleSetSubscriptionData("hd_priority", selectedOption?.value)}
                                                                    options={priorityLevels}
                                                                    isSearchable={true}
                                                                    placeholder={t('priority').toUpperCase()}
                                                                    isDisabled={documentEnabled === "N"}
                                                                /> :
                                                                <input
                                                                    id="hd_priority_xx"
                                                                    name="hd_priority_xx"
                                                                    type="text"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={subscriptionData?.hd_priority}
                                                                    disabled={true}
                                                                />}
                                                        </div>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_gl_date"
                                                                className="form-dropdown-label"
                                                            >
                                                                {t('glDate').toUpperCase()}
                                                            </label>
                                                            <input
                                                                id="hd_gl_date"
                                                                name="hd_gl_date"
                                                                type="date"
                                                                placeholder={t('glDate').toUpperCase()}
                                                                className="form-input-item"
                                                                style={{ width: "170px" }}
                                                                value={subscriptionData?.hd_gl_date}
                                                                onChange={(e) => {
                                                                    try {
                                                                        const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                        handleSetSubscriptionData("hd_gl_date", formattedDate);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                                disabled={documentEnabled === "N"}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="input-item-with-label" style={{ width: "100%" }}>
                                                        <label
                                                            htmlFor="hd_ref_no"
                                                            className="form-dropdown-label"
                                                            style={{ width: "120px", alignSelf: "flex-start" }}
                                                        >
                                                            {t('narration').toUpperCase()}
                                                        </label>
                                                        <textarea
                                                            id="hd_narration"
                                                            name="hd_narration"
                                                            type="text"
                                                            rows={3.5}
                                                            placeholder={t('narration').toUpperCase()}
                                                            value={subscriptionData?.hd_narration}
                                                            className="form-input-item"
                                                            style={{ width: "100%" }}
                                                            onChange={selectedOption => handleSetSubscriptionData("hd_narration", selectedOption?.value)}
                                                            disabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="content-details-right">
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="hd_no" className="form-dropdown-label">
                                                            {t('no').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="hd_no"
                                                            name="hd_no"
                                                            type="text"
                                                            placeholder={t('no').toUpperCase()}
                                                            value={subscriptionData?.hd_no}
                                                            className="form-input-item"
                                                            style={{ width: "200px" }}
                                                            onChange={selectedOption => handleSetSubscriptionData("hd_no", selectedOption?.value)}
                                                            disabled={subscriptionData?.hd_no}
                                                        />
                                                    </div>

                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="hd_lc_amount"
                                                            className="form-dropdown-label"
                                                            style={{ width: "100px" }}
                                                        >
                                                            {t('amount').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="hd_lc_amount"
                                                            name="hd_lc_amount"
                                                            type="text"
                                                            placeholder="0.00"
                                                            className="form-input-item"
                                                            style={{ width: "200px", textAlign: "end" }}
                                                            value={numeral(totalReceiptLc).format("0,0.00")}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="total_fees_lc"
                                                            className="form-dropdown-label"
                                                        >
                                                            {t('fees').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="total_fees_lc"
                                                            name="total_fees_lc"
                                                            type="text"
                                                            placeholder={t('fees').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px", textAlign: "end" }}
                                                            value={numeral(subscriptionData?.total_fees_lc).format("0,0.00")}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="net_amount_lc"
                                                            className="form-dropdown-label"
                                                        >
                                                            {t('net').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="net_amount_lc"
                                                            name="net_amount_lc"
                                                            type="text"
                                                            placeholder={t('net').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px", textAlign: "end" }}
                                                            value={numeral(subscriptionData?.net_amount_lc).format("0,0.00")}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="nav_per_unit"
                                                            className="form-dropdown-label"
                                                            style={{ width: "100px" }}
                                                        >
                                                            {t('nav').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="nav_per_unit"
                                                            name="nav_per_unit"
                                                            type="text"
                                                            placeholder={t('glDate').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px", textAlign: "end" }}
                                                            value={subscriptionData?.nav_per_unit}
                                                            // onChange={(e) => handleSetSubscriptionData("nav_per_unit", e.target.value)}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="units_allocated"
                                                            className="form-dropdown-label"
                                                        >
                                                            {t('units').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="units_allocated"
                                                            name="units_allocated"
                                                            type="text"
                                                            placeholder={t('units').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px", textAlign: "end" }}
                                                            value={subscriptionData?.units_allocated}
                                                            onChange={(e) => handleSetSubscriptionData("units_allocated", e.target.value)}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </ExpandableComponent>
                                        {/*  receipt details */}
                                        <ExpandableComponent
                                            title={t('receipts').toUpperCase()}
                                            subtitle={
                                                subscriptionDocId !== "new" &&
                                                documentEnabled === "Y" &&
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                    <Select
                                                        id="receipt_line"
                                                        name="receipt_line"
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                            menuPortal: base => ({
                                                                ...base,
                                                                zIndex: 9999,
                                                            })
                                                        }}
                                                        width="350px"
                                                        value={selectedReceipt}
                                                        onChange={(selectedOption) => setSelectedReceipt(selectedOption)}
                                                        options={entityReceipts}
                                                        isSearchable={true}
                                                        placeholder={t('receipt').toUpperCase()}
                                                        isDisabled={documentEnabled === "N"}
                                                    />
                                                    <CircularButton currentTheme={currentTheme}
                                                        onClick={async (e) => {
                                                            try {

                                                                if (!selectedReceipt) {
                                                                    setNotifyDialogTitle("Note!");
                                                                    setNotifyDialogText(`Please select receipt to add`);
                                                                    setIsNotifyDialogOpen(true);
                                                                    return;
                                                                }

                                                                const res = await newRequest.post(
                                                                    "/fundSub/addReceipt",
                                                                    {
                                                                        subscription_docid: subscriptionDocId,
                                                                        receipt_docid: selectedReceipt?.receipt_docid,
                                                                        receipt_line_docid: selectedReceipt?.line_docid,
                                                                        receipt_fc_amount: selectedReceipt?.ln_fc_amount,
                                                                        receipt_lc_amount: selectedReceipt?.ln_lc_amount,
                                                                    }
                                                                );

                                                                if (res.data?.msg === "added") {
                                                                    setSubscriptionReceipts((prevData) => [...prevData, {
                                                                        ...res.data?.doc,
                                                                        receipt_fc_amount: formatAmountsToDecimals(res.data?.doc?.receipt_fc_amount, 2),
                                                                        receipt_lc_amount: formatAmountsToDecimals(res.data?.doc?.receipt_lc_amount, 2),
                                                                    }]);
                                                                    setSelectedReceipt(null);
                                                                    if (receiptRef.current) {
                                                                        receiptRef.current.focus();
                                                                    }
                                                                    showToast(t('added'), "success");
                                                                } else if (res.data?.msg === "exists") {
                                                                    setSelectedReceipt(null);
                                                                    showToast(`Already added`, "warning");
                                                                } else {
                                                                    showToast(res.data?.msg, "error");
                                                                }

                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }} icon={<MdAdd />} width={"35px"} height={"35px"} />
                                                </div>
                                            }
                                            defaultExpanded={subscriptionReceipts?.length > 0}
                                        >
                                            <div className="available-services">
                                                <div className="table-content">
                                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                                            <TableBody className="tablebody">
                                                                {subscriptionReceipts?.map((row, index) => (
                                                                    <TableRow
                                                                        key={row?._id}
                                                                        className={`${selectedSubReceipt?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                        onClick={() => setSelectedSubReceipt(row)}
                                                                    >
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                            <div style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "space-between", width: "100%" }}>
                                                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px", flex: "1" }}>
                                                                                    <span className="sub-title">{row?.ln_hd_no}</span>
                                                                                    <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.hd_mode}</span>
                                                                                </div>
                                                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px", flex: "1" }}>
                                                                                    <span className="sub-title">{row?.hd_gl_date_xx}</span>
                                                                                    <span className="sub-title soft" style={{ fontSize: "10px" }}>{`${t('ref')} : ${row?.hd_ref_no}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                            {documentEnabled === "Y" ?
                                                                                <div className="input-item-with-label">
                                                                                    <input
                                                                                        id="receipt_lc_amount"
                                                                                        name="receipt_lc_amount"
                                                                                        type="text"
                                                                                        value={row?.receipt_lc_amount}
                                                                                        onChange={(e) => handleSubReceiptChange(e, row?._id, 'receipt_lc_amount')}
                                                                                        onBlur={() => handleSubReceiptBlur(row?._id, "receipt_lc_amount")}
                                                                                        style={{ width: "100%", textAlign: "right" }}
                                                                                        className="form-input-item table"
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <span className="sub-title">{numeral(row?.receipt_lc_amount).format("0,0.00")}</span>}
                                                                        </TableCell>
                                                                        {/* <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                            <span className="sub-title">{numeral(row?.receipt_fc_amount).format("0,0.00")}</span>
                                                                        </TableCell> */}
                                                                        {documentEnabled === "Y" &&
                                                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                                <CircularButton
                                                                                    currentTheme={currentTheme}
                                                                                    onClick={async (e) => {
                                                                                        try {
                                                                                            const res = await newRequest.post("/fundSub/removeReceipt",
                                                                                                {
                                                                                                    subscription_docid: subscriptionDocId,
                                                                                                    receipt_docid: row?.receipt_docid,
                                                                                                    receipt_line_docid: row?.receipt_line_docid
                                                                                                });

                                                                                            if (res.data?.msg === "removed") {
                                                                                                setSubscriptionReceipts((prevData) =>
                                                                                                    prevData.filter(doc => doc?.receipt_docid.toString() !== row?.receipt_docid.toString() &&
                                                                                                        doc?.receipt_line_docid.toString() !== row?.receipt_line_docid.toString())
                                                                                                );
                                                                                                showToast(t('removed'), "success");
                                                                                            } else {
                                                                                                showToast("Error deleting report!", "error");
                                                                                            }
                                                                                        } catch (error) {
                                                                                            console.log(error);
                                                                                        }
                                                                                    }} color="#E53935" icon={<MdDelete/>} width={"30px"} height={"30px"} />
                                                                            </TableCell>}
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </div>
                                        </ExpandableComponent>
                                        {/* end of receipt details */}
                                        {/* fees */}
                                        <ExpandableComponent
                                            title={t('fees').toUpperCase()}
                                            subtitle={
                                                <span className="main-title" style={{ fontSize: "18px" }}>{`${t('totalFees')} : ${subscriptionData?.hd_cur_code} ${numeral(totalFeesLc).format("0,0.00")}`}</span>
                                            }
                                            defaultExpanded={true}
                                        >
                                            <div className="available-services">
                                                <div className="table-content">
                                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                                            <TableBody className="tablebody">
                                                                {subscriptionFees?.map((row, index) => (
                                                                    <TableRow
                                                                        key={row?._id}
                                                                        className={`${selectedFee?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                        onClick={() => {
                                                                            try {
                                                                                setSelectedFee(row);
                                                                            } catch (error) {
                                                                                console.log(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                            <div style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "space-between", width: "100%" }}>
                                                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px", flex: "1" }}>
                                                                                    <span className="sub-title">{row?.fee_name_xx}</span>
                                                                                    <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.fee_code}</span>
                                                                                </div>
                                                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px", flex: "1" }}>
                                                                                    <span className="sub-title">{row?.fee_category_xx}</span>
                                                                                    {row?.rate_type === "Fixed Amount" ? <span className="sub-title soft" style={{ fontSize: "10px" }}>{`${t('fixedAmount')}`}</span>
                                                                                        :
                                                                                        <span className="sub-title soft" style={{ fontSize: "10px" }}>{`${row?.rate}% On ${row?.applicable_on}`}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                                                            <span className="sub-title">{`${subscriptionData?.hd_cur_code} : ${numeral(row?.fee_amount_lc).format("0,0.00")}`}</span>
                                                                            <span className="sub-title soft" style={{ fontSize: "10px" }}>{`${t('converted')} ${numeral(row?.fee_amount_fc).format("0,0.00")}`}</span>
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "50px" }} />
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </div>
                                        </ExpandableComponent>
                                        {/* end of fees */}
                                        {/* T-Account after posting document */}
                                        {["Approved", "Cancelled"].includes(subscriptionData?.hd_status) &&
                                            <Taccount key={subscriptionData?.hd_status} originalDocId={subscriptionDocId} originalDocno={subscriptionData?.hd_no} originalDocType={"AM Fund Sub"} endorsementIndex={0} />}
                                    </>
                                }
                                {activeTab === 1 && <>
                                    <motion.div
                                        className="tabs-view-wrapper"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}>
                                        <div className="attachment">
                                            <FileUploadComponent 
                                            documentNo={subscriptionData?.hd_no} 
                                            documentId={subscriptionDocId} 
                                            documentType="am fund sub" 
                                            fetchDocumentAttachments={fetchDocumentAttachments} 
                                            uploadFolder="am_fund_sub" />
                                            <div className="attachment-files">
                                                <AllFiles filesList={attachmentsData} />
                                            </div>
                                        </div>
                                    </motion.div>
                                </>}
                                {activeTab === 2 &&
                                    <motion.div
                                        className="correspondence"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}
                                    >
                                        <HRHandbook />
                                    </motion.div>
                                }
                                {activeTab === 3 &&
                                    <motion.div
                                        className="correspondence"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}
                                    >
                                        <Correspondence
                                            correspondenceParams={{ fetch_type: "document", doc_id: subscriptionDocId, doc_no: subscriptionData?.hd_no, doc_type: "Receipt", entity_codes: [subscriptionData?.hd_ent_code?.value] }}
                                            passedEmailData={{
                                                to: `${subscriptionData?.client_email_xx}`,
                                                cc: `${currentUser?.usr_email}`,
                                                bcc: '',
                                                subject: `Receipt No ${subscriptionData?.hd_no}`,
                                                show_attach: "Y",
                                                attached_urls: [],
                                                binary_docs: [],
                                                doc_no: subscriptionData?.hd_no,
                                                doc_type: "AM Fund Sub",
                                                doc_id: subscriptionDocId,
                                                entity_codes: [subscriptionData?.hd_ent_code?.value],
                                                search_string: subscriptionData?.hd_ent_code?.label?.props?.children[0] + "," + subscriptionData?.hd_no,
                                                carrierName: "",
                                                productName: "",
                                                clientName: subscriptionData?.hd_ent_code?.label?.props?.children[0],
                                                riskNoteNo: subscriptionData?.hd_no,
                                                daysToRenewal: 0,
                                                expiryDate: "",
                                                insuredName: subscriptionData?.hd_ent_code?.label?.props?.children[0],
                                                outstandingPremium: 0,
                                                policyCurrency: subscriptionData?.hd_cur_code,
                                                policyNumber: subscriptionData?.hd_no,
                                                policyPremium: "",
                                                policyPremiumTotal: "",
                                                policySumInsured: "",
                                                policyFromDate: "",
                                                policyToDate: "",
                                                tpt_category: []
                                            }} />
                                    </motion.div>
                                }
                                {activeTab === 4 &&
                                    <motion.div
                                        className="content-details-row"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}
                                    >
                                        <AllDocsNote
                                            docId={subscriptionData._id}
                                            docType="AM Fund Sub"
                                            noteType={"Normal"}
                                        />
                                    </motion.div>
                                }
                            </div>
                        </div>
                        <div className="subscription-summary-wrapper">
                            <div className="summary-content">
                                <WorkedOnBy name={subscriptionData?.updated_by_name_xx} photoUrl={subscriptionData?.updated_by_photo_url_xx} time_ago_xx={subscriptionData?.time_ago_xx} />
                                <hr className="separator-h" />
                                {subscriptionData?.hd_cur_code !== currentUser?.currency_code_xx && (
                                    <div
                                        className="input-item-with-label"
                                        style={{ alignSelf: "flex-end" }}
                                    >
                                        <label
                                            htmlFor="hd_cur_rate"
                                            className="form-dropdown-label"
                                        >
                                            {t('rate').toUpperCase()}
                                        </label>
                                        <input
                                            id="hd_cur_rate"
                                            name="hd_cur_rate"
                                            type="number"
                                            placeholder="0.00"
                                            value={subscriptionData?.hd_cur_rate}
                                            className="form-input-item"
                                            style={{
                                                width: "100px",
                                                margin: "5px 0px",
                                                textAlign: "right",
                                            }}
                                            // onChange={(e) => setHdCurRate(e.target.value)}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                )}
                                <motion.div
                                    className="summary-view"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1, transition: { duration: 1 } }}
                                    exit={{ opacity: 0, transition: { duration: 1 } }}
                                >
                                    <div className="title-row">
                                        <span className="sub-title">{t('summary').toUpperCase()}</span>
                                        {currentUser?.currency_code_xx !== subscriptionData?.hd_cur_code && (
                                            <CustomButtonSmall
                                                style={{ display: "flex" }}
                                                onClick={() => {
                                                    try {
                                                        if (figuresToShow === "org") {
                                                            setFiguresToShow("base");
                                                        } else {
                                                            setFiguresToShow("org");
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                            >
                                                {figuresToShow === "org"
                                                    ? `view ${currentUser?.currency_code_xx}`
                                                    : `view ${subscriptionData?.hd_cur_code}`}
                                            </CustomButtonSmall>
                                        )}
                                        <h1 className="main-title currency">
                                            {figuresToShow === "org"
                                                ? `${subscriptionData?.hd_cur_code}`
                                                : `${currentUser?.currency_code_xx}`}
                                        </h1>
                                    </div>
                                    <hr className="separator-h" />
                                    <div className="content-row">
                                        <span className="sub-title"> {t('investing').toUpperCase()} </span>
                                        <span span className="receipt-amount">  {numeral(subscriptionData?.hd_lc_amount).format("0,0.00")}   </span>
                                    </div>
                                    <div className="content-row">
                                        <span className="amount-to-words">{`${currentUser?.currency_code_xx} ${numberToWordsWithDecimal(subscriptionData?.hd_lc_amount)}`}</span>
                                    </div>

                                    <hr className="separator-h" />
                                    <div className="content-row">
                                        <span className="sub-title"> {t('fees').toUpperCase()} </span>
                                        <span span className="receipt-amount"> {numeral(subscriptionData?.total_fees_lc).format("0,0.00")}   </span>
                                    </div>
                                    <div className="content-row">
                                        <span className="sub-title"> {t('net').toUpperCase()} </span>
                                        <span span className="receipt-amount"> {numeral(subscriptionData?.net_amount_lc).format("0,0.00")}  </span>
                                    </div>
                                    <div className="content-row">
                                        <span className="sub-title"> {t('usedNav').toUpperCase()} </span>
                                        <span span className="receipt-amount">{`${subscriptionData?.hd_cur_code} : ${numeral(subscriptionData?.nav_per_unit).format("0,0.00")}`}</span>
                                    </div>
                                    <div className="content-row">
                                        <span className="sub-title"> {t('units').toUpperCase()} </span>
                                        <span span className="receipt-amount">{numeral(subscriptionData?.units_allocated).format("0,0.00")}</span>
                                    </div>

                                    <hr className="separator-h" />
                                    <h1 className="sub-title" style={{ textAlign: "center" }}>{t('timeline').toUpperCase()}</h1>
                                    <hr className="separator-h" />
                                    <div className="timeline-root">
                                        {traceData.map((item) => (
                                            <div key={item?._id} className="timeline-item">
                                                <div className="timeline-separator">
                                                    <div className="timeline-dot"></div>
                                                    <div className="timeline-connector" />
                                                </div>
                                                <div className="timeline-content">
                                                    <div className="timeline-navbar">
                                                        <div className="avatar-container">
                                                            {item?.updated_by_photo_url_xx ?
                                                                <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" /> : <CiImageOn style={{ width: "30px", height: "30px" }} />}
                                                            <span className="username">{item?.updated_by_name_xx}</span>
                                                        </div>
                                                        <span className="time-ago">{item?.time_ago_xx}</span>
                                                    </div>
                                                    <div className="remarks">
                                                        {item?.trc_remarks}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {validationMsgDialog && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('messages')}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => setValidationMsgDialog(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <ValidationMessages messageData={validationMessagesResult} />
                        </div>
                    </div>
                </motion.div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={handleCloseNotifyDialog}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notifyDialogText) }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        endIcon={<MdClose />}
                        onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t("confirmation")}
                dialogContent={<p>{objectToAction.action_text}</p>}
            />
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
            {/* email component */}
            {emailDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <span className="main-title">{t('email').toUpperCase()}</span>
                            <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
                        </div>
                    </div>
                </motion.div>
            )}
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={subscriptionData?.report_keys_array}
                                documentData={{
                                    docNo: subscriptionData?.hd_no,
                                    docType: "AM Fund Sub",
                                    docId: subscriptionDocId,
                                    sub_docid: subscriptionDocId,

                                }} />
                        </div>
                    </div>
                </motion.div>
            )}
            {isConfettiActive && <Confetti />}
        </motion.div>
    );
};


export default AmSub;
